import axios from 'axios'
import Vue from 'vue'

axios.defaults.baseURL = process.env.BASE_URL;
;
axios.defaults.headers.post['Content-Type'] = 'application/json;charset=UTF-8';
axios.defaults.timeout = 10000;

export const fileUploadUrl = `${axios.defaults.baseURL}api/file/upload`;
export const fileDownloadUrl = `${axios.defaults.baseURL}api/file/downloadfile?path=`;

export const get = (url, params, successCallback, failCallback) => {
    let config = _initHeader(url);

    if (params.pageInfo) {
        config.headers['pageNo'] = params.pageInfo.pageNo;
        config.headers['pageSize'] = params.pageInfo.pageSize;
    }

    if (params.params) {
        let ps = new Array();
        for (let k in params.params) {
            ps.push(`${k}=${params.params[k]}`)
        }
        if (ps.length > 0) {
            url = `${url}?${ps.join('&')}`
        }
    }
    url = encodeURI(url);

    axios.get(`api/${url}`, config).then(res => {
        let data = res.data;
        if (data.code == -1001) {
            Vue.prototype.$tools.toast('登录超时');
            setTimeout(() => {
                window.sessionStorage.clear();
                window.location.reload();
            }, 1000)
            return;
        }
        if (data.code <= 0) {
            Vue.prototype.$message.error(data.msg);
            if (failCallback) {
                failCallback();
            }
        } else {
            if (res.headers.total) {
                data.data.listTotal = res.headers.total
            }
            successCallback(data.data)
        }
    }).catch(error => {

        _errorHandle(error, failCallback)
    });
};


export const post = (url, params, successCallback, failCallback) => {
    let config = _initHeader(url);

    if (!params) {
        params = {}
    }

    axios.post(`api/${url}`, params, config).then(res => {
        _successHandle(res, successCallback, failCallback)
    }).catch(error => {
        _errorHandle(error, failCallback)
    });
};

export const put = (url, params, successCallback, failCallback) => {
    let config = _initHeader(url);

    if (!params) {
        params = {}
    }

    axios.put(`api/${url}`, params, config).then(res => {
        _successHandle(res, successCallback, failCallback)
    }).catch(error => {
        _errorHandle(error, failCallback)
    });
};

export const del = (url, successCallback, failCallback) => {
    let config = _initHeader(url);

    axios.delete(`api/${url}`, config).then(res => {
        _successHandle(res, successCallback, failCallback)
    }).catch(error => {
        _errorHandle(error, failCallback)
    });
};

let _initHeader = (url) => {
    let config = {headers: {}};

    if (url.indexOf('logon') > -1) {
        config.headers['Authorization'] = `bearer ${sessionStorage.token}`;
    }
    return config
}

let _successHandle = (res, successCallback, failCallback) => {
    let data = res.data;
    if (data.code == -1001) {
        Vue.prototype.$tools.toast('登录超时');
        setTimeout(() => {
            window.sessionStorage.clear();
            window.location.reload();
        }, 1000)
        return;
    }
    if (data.code <= 0) {
        Vue.prototype.$tools.toast(data.msg);
        if (failCallback) {
            failCallback();
        }
    } else {
        successCallback(data.data)
    }
}

let _errorHandle = (error, failCallback) => {
    if (error.response) {
        // 请求已发出，但服务器响应的状态码不在 2xx 范围内
        console.log(error.response.data);
        console.log(error.response.status);
        console.log(error.response.headers);
    } else {
        // Something happened in setting up the request that triggered an Error
        console.log('Error', error.message);
    }
    Vue.prototype.$tools.toast('服务异常，请稍后重试');
    if (failCallback) {
        failCallback();
    }
}


// WEBPACK FOOTER //
// ./src/assets/js/api.js